import { render, staticRenderFns } from "./OptionsInfo.vue?vue&type=template&id=0fc8bdf4&scoped=true&"
import script from "./OptionsInfo.vue?vue&type=script&lang=ts&"
export * from "./OptionsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8bdf4",
  null
  
)

export default component.exports